import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import TextField from "../../../../../../../ui/TextField";

const defaultData = {
  name: ""
};

const styles = () => ({
  root: {
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  block: {
    margin: "35px 0 15px 0"
  }
});

const AddRoomTypeForm = ({ disabled, onFormChange, initialData, classes }) => {
  const formdata = initialData ? initialData : defaultData;
  const [data, setData] = React.useState(formdata);
  const { name } = data;

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  return (
    <div className={classes.root}>
      <TextField
        value={name}
        onChange={e => onChange("name", e.target.value)}
        label="Наименование"
        disabled={disabled}
      />
    </div>
  );
};

export default withStyles(styles)(AddRoomTypeForm);
